// import components
import {
  styled,
  FormControl,
  FormControlProps,
  FormLabel,
  FormLabelProps,
  ToggleButton
} from '@mui/material';

export const StyledToggleButtonFormControl = styled(FormControl, {
  shouldForwardProp: (prop) => prop !== 'direction'
})<FormControlProps & { direction: 'row' | 'column' }>(
  ({ direction = 'row' }) => ({
    flexDirection: direction,
    ...(direction === 'row'
      ? { alignItems: 'center', justifyContent: 'space-between' }
      : { justifyContent: 'center' })
  })
);

export const StyledToggleButtonFormLabel = styled(FormLabel)<FormLabelProps>(
  ({ theme }) => ({
    color: theme.palette.text.primary,
    marginLeft: 0,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  })
);

export const StyledToggleButton = styled(ToggleButton)<FormLabelProps>(() => ({
  textTransform: 'none',
  whiteSpace: 'nowrap'
}));
